<template>
  <div id="index">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <template>
          <el-row :gutter="24">
            <el-col :xs="24" :sm="12" :lg="8">
              <el-button
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="dialogMenu('First')"
                style="margin-bottom: 10px"
                v-show="hasCreateAuth"
                >{{ $t("button.createFirstLevelMenu") }}
              </el-button>
              <el-button
                type="primary"
                plain
                icon="el-icon-circle-plus-outline"
                @click="dialogMenu('Second')"
                style="margin-bottom: 10px"
                v-show="hasCreateAuth"
                >{{ $t("button.createSecondLevelMenu") }}
              </el-button>
              <div class="custom-tree-container">
                <div class="block">
                  <el-tree
                    :data="MenuData"
                    node-key="id"
                    default-expand-all
                    @node-click="handleNodeClick"
                    :empty-text="$t('desc.noData')"
                    :expand-on-click-node="false"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ $t("menu." + data.code) }}</span>
                      <span class="fr">
                        <el-button
                          type="primary"
                          v-show="hasUpdateAuth"
                          @click="editMenu(data)"
                          :title="$t('button.update')"
                          icon="el-icon-edit"
                          circle
                        ></el-button>
                        <el-button
                          type="danger"
                          v-show="hasDeleteAuth"
                          @click="deleteId(data.id)"
                          :title="$t('button.delete')"
                          icon="el-icon-delete"
                          circle
                        ></el-button>
                      </span>
                      <span class="clear"></span>
                    </span>
                  </el-tree>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="16">
              <div v-if="dialogFirst">
                <h3 class="menutitle">
                  {{ $t("button.createFirstLevelMenu") }}
                </h3>
                <el-form
                  ref="menuform"
                  :model="menuform"
                  label-width="120px"
                  class="menutable"
                >
                  <el-form-item :label="$t('desc.NO')" prop="code">
                    <el-input v-model="menuform.code"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.name')"
                    prop="name"
                    :rules="[{ required: true, message: $t('tips.enterName') }]"
                  >
                    <el-input v-model="menuform.name"></el-input>
                  </el-form-item>
                  <el-form-item
                    label="URL"
                    prop="url"
                    :rules="[{ required: true, message: $t('tips.enterUrl') }]"
                  >
                    <el-input v-model="menuform.url"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('desc.icon')" prop="icon">
                    <!-- <i v-if="menuform.icon" :class="menuform.icon" style="color:#fff;"></i> -->
                    <el-input
                      v-model="menuform.icon"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.describe')"
                    prop="description"
                    :rules="[
                      { required: true, message: $t('tips.enterDescribe') },
                    ]"
                  >
                    <el-input
                      v-model="menuform.description"
                      type="textarea"
                      :rows="2"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.sort')"
                    prop="sortNum"
                    :rules="[{ required: true, message: $t('tips.enterSort') }]"
                  >
                    <el-input
                      type="number"
                      :min="1"
                      v-model="menuform.sortNum"
                      style="max-width: 100px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.isEnable')"
                    prop="isEnable"
                    :rules="[{ required: true, message: $t('desc.select') }]"
                  >
                    <el-select
                      v-model="menuform.isEnable"
                      :placeholder="$t('desc.select')"
                      style="max-width: 100px"
                    >
                      <el-option value="0" :label="$t('desc.yes')"></el-option>
                      <el-option value="1" :label="$t('desc.no')"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="onSubmit('menuform')">{{
                      $t("button.confirm")
                    }}</el-button>
                    <el-button @click="dialogFirst = false">{{
                      $t("button.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="dialogSecond">
                <h3 class="menutitle">
                  {{ $t("button.createSecondLevelMenu") }}
                </h3>
                <el-form
                  ref="menuform"
                  :model="menuform"
                  label-width="120px"
                  class="menutable"
                >
                  <el-form-item :label="$t('desc.NO')" prop="code">
                    <el-input v-model="menuform.code"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.name')"
                    prop="name"
                    :rules="[{ required: true, message: $t('tips.enterName') }]"
                  >
                    <el-input v-model="menuform.name"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.parentMenu')"
                    prop="parentId"
                    :rules="[
                      { required: true, message: $t('tips.enterParentMenu') },
                    ]"
                  >
                    <el-select
                      v-model="menuform.parentId"
                      :placeholder="$t('desc.select')"
                    >
                      <el-option
                        v-for="(item, index) in MenuData"
                        :key="'inx2' + index"
                        :label="$t('menu.' + item.code)"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="URL"
                    prop="url"
                    :rules="[{ required: true, message: $t('tips.enterUrl') }]"
                  >
                    <el-input v-model="menuform.url"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('desc.icon')" prop="icon">
                    <!-- <i v-if="menuform.icon" :class="menuform.icon" style="color:#fff;"></i> -->
                    <el-input
                      v-model="menuform.icon"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.describe')"
                    prop="description"
                    :rules="[
                      { required: true, message: $t('tips.enterDescribe') },
                    ]"
                  >
                    <el-input
                      v-model="menuform.description"
                      type="textarea"
                      :rows="2"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.sort')"
                    prop="sortNum"
                    :rules="[{ required: true, message: $t('tips.enterSort') }]"
                  >
                    <el-input
                      type="number"
                      :min="1"
                      v-model="menuform.sortNum"
                      style="max-width: 100px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.isEnable')"
                    prop="isEnable"
                    :rules="[{ required: true, message: $t('desc.select') }]"
                  >
                    <el-select
                      v-model="menuform.isEnable"
                      :placeholder="$t('desc.select')"
                      style="max-width: 100px"
                    >
                      <el-option value="0" :label="$t('desc.yes')"></el-option>
                      <el-option value="1" :label="$t('desc.no')"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="onSubmit('menuform')">{{
                      $t("button.confirm")
                    }}</el-button>
                    <el-button @click="dialogSecond = false">{{
                      $t("button.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <div v-if="dialogFirstEdit">
                <h3 class="menutitle">
                  {{ $t("button.editFirstLevelMenu") }}
                </h3>
                <el-form
                  ref="menuform"
                  :model="menuform"
                  label-width="120px"
                  class="menutable"
                >
                  <el-form-item :label="$t('desc.NO')" prop="code">
                    <el-input v-model="menuform.code"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.name')"
                    prop="name"
                    :rules="[{ required: true, message: $t('tips.enterName') }]"
                  >
                    <el-input v-model="menuform.name"></el-input>
                  </el-form-item>
                  <el-form-item
                    label="URL"
                    prop="url"
                    :rules="[{ required: true, message: $t('tips.enterUrl') }]"
                  >
                    <el-input v-model="menuform.url"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('desc.icon')" prop="icon">
                    <!-- <i v-if="menuform.icon" :class="menuform.icon" style="color:#fff;"></i> -->
                    <el-input
                      v-model="menuform.icon"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.describe')"
                    prop="description"
                    :rules="[
                      { required: true, message: $t('tips.enterDescribe') },
                    ]"
                  >
                    <el-input
                      v-model="menuform.description"
                      type="textarea"
                      :rows="2"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.sort')"
                    prop="sortNum"
                    :rules="[{ required: true, message: $t('tips.enterSort') }]"
                  >
                    <el-input
                      type="number"
                      :min="1"
                      v-model="menuform.sortNum"
                      style="max-width: 100px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.isEnable')"
                    prop="isEnable"
                    :rules="[{ required: true, message: $t('desc.select') }]"
                  >
                    <el-select
                      v-model="menuform.isEnable"
                      :placeholder="$t('desc.select')"
                      style="max-width: 100px"
                    >
                      <el-option value="0" :label="$t('desc.yes')"></el-option>
                      <el-option value="1" :label="$t('desc.no')"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="onSubmit('menuform')">{{
                      $t("button.confirm")
                    }}</el-button>
                    <el-button @click="dialogFirstEdit = false">{{
                      $t("button.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <div v-if="dialogSecondEdit">
                <h3 class="menutitle">
                  {{ $t("button.editSecondLevelMenu") }}
                </h3>
                <el-form
                  ref="menuform"
                  :model="menuform"
                  label-width="120px"
                  class="menutable"
                >
                  <el-form-item :label="$t('desc.NO')" prop="code">
                    <el-input v-model="menuform.code"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.name')"
                    prop="name"
                    :rules="[{ required: true, message: $t('tips.enterName') }]"
                  >
                    <el-input v-model="menuform.name"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.parentMenu')"
                    prop="parentId"
                    :rules="[
                      { required: true, message: $t('tips.enterParentMenu') },
                    ]"
                  >
                    <el-select
                      v-model="menuform.parentId"
                      :placeholder="$t('desc.select')"
                    >
                      <el-option
                        v-for="(item, index) in MenuData"
                        :key="'inx1' + index"
                        :label="$t('menu.' + item.code)"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="URL"
                    prop="url"
                    :rules="[{ required: true, message: $t('tips.enterUrl') }]"
                  >
                    <el-input v-model="menuform.url"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('desc.icon')" prop="icon">
                    <!-- <i v-if="menuform.icon" :class="menuform.icon" style="color:#fff;"></i> -->
                    <el-input
                      v-model="menuform.icon"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.describe')"
                    prop="description"
                    :rules="[
                      { required: true, message: $t('tips.enterDescribe') },
                    ]"
                  >
                    <el-input
                      v-model="menuform.description"
                      type="textarea"
                      :rows="2"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.sort')"
                    prop="sortNum"
                    :rules="[{ required: true, message: $t('tips.enterSort') }]"
                  >
                    <el-input
                      type="number"
                      :min="1"
                      v-model="menuform.sortNum"
                      style="max-width: 100px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('desc.isEnable')"
                    prop="isEnable"
                    :rules="[{ required: true, message: $t('desc.select') }]"
                  >
                    <el-select
                      v-model="menuform.isEnable"
                      :placeholder="$t('desc.select')"
                      style="max-width: 100px"
                    >
                      <el-option value="0" :label="$t('desc.yes')"></el-option>
                      <el-option value="1" :label="$t('desc.no')"></el-option>
                    </el-select>
                  </el-form-item>
                  <!--                            <el-form-item label="是否删除">-->
                  <!--                                <el-select v-model="menuform.det" :placeholder="$t('desc.select')" style="max-width: 100px;">-->
                  <!--                                    <el-option value="0" label="是">是</el-option>-->
                  <!--                                    <el-option value="1" label="否">否</el-option>-->
                  <!--                                </el-select>-->
                  <!--                            </el-form-item>-->
                  <el-form-item>
                    <el-button type="success" @click="onSubmit('menuform')">{{
                      $t("button.confirm")
                    }}</el-button>
                    <el-button @click="dialogSecondEdit = false">{{
                      $t("button.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </el-row>
        </template>
      </el-main>
    </el-scrollbar>

    <el-dialog
      :title="$t('title.chooseIcon')"
      :visible.sync="dialogTableVisible"
    >
      <el-row :gutter="24" class="icons">
        <div
          class="iconList"
          v-for="(item, index) in icons"
          @click="getIcon(item)"
          :key="index"
        >
          <i :class="item"></i>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
//@focus="dialogTableVisible = true" 
//style="width: 94%; margin-left: 2%"
import {
  CreateMenu,
  GetAllMenus,
  DeleteMenu,
  UpdateMenu,
  authOperationCheck,
} from "../../api/api";
import { icons } from "../../assets/fonts/font-awesome";
import { mapState } from "vuex";

export default {
  name: "index",
  async mounted() {
    this.getDataList();
    this.icons = icons;
  },
  data() {
    return {
      dialogFirst: false,
      dialogSecond: false,
      dialogTableVisible: false,
      dialogFirstEdit: false,
      dialogSecondEdit: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      menuLevel: 0,
      icons: [],
      activeParentId: "",
      menuform: {
        name: "",
        code: "",
        isEnable: "0",
        parentId: "",
        url: "",
        icon: "",
        description: "",
        sortNum: "",
      },
      MenuData: [],
    };
  },
  created: function () {
    this.authOperation("Menu");
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
    },
    handleNodeClick(data) {
      if (data.parentId == "00000000-0000-0000-0000-000000000000") {
        this.activeParentId = data.id;
        this.menuform.parentId = data.id;
      } else {
        this.activeParentId = "";
        this.menuform.parentId = data.parentId;
      }
    },
    openNotice() {
      this.$notify({
        title: "警告",
        message: "这是一条警告的提示消息",
        type: "warning",
      });
    },
    getIcon(e) {
      this.menuform.icon = e;
      this.dialogTableVisible = false;
    },
    deleteId(id) {
      let that = this;
      let data = { Id: id };
      this.$confirm(this.$t("title.confirmDelete"), this.$t("title.tips"), {
        confirmButtonText: this.$t("button.confirm"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          DeleteMenu(data).then((res) => {
            if (res.success) {
              that.$message.success(this.$t("tips.deleteSuccess"));
            }
            that.getDataList();
          });
        })
        .catch(() => {});
    },
    dialogMenu(m) {
      this.menuform = {
        name: "",
        isEnable: "0",
        parentId: this.activeParentId == "" ? "" : this.activeParentId,
        url: "",
        icon: "",
        description: " ",
        sortNum: 1,
      };
      delete this.menuform.id;
      // if(this.dialogFirst || this.dialogSecond || this.dialogFirstEdit || this.dialogSecondEdit){
      // this.dialogFirst = false;this.dialogSecond = false;
      // this.dialogFirstEdit = false; this.dialogSecondEdit = false;
      // }
      // else{
      if (m === "First") {
        this.menuLevel = 0;
        this.dialogFirst = !this.dialogFirst;
        this.dialogSecond = false;
        this.dialogFirstEdit = false;
        this.dialogSecondEdit = false;
      } else {
        this.menuLevel = 1;
        this.dialogFirst = false;
        this.dialogSecond = !this.dialogSecond;
        this.dialogFirstEdit = false;
        this.dialogSecondEdit = false;
      }
      // }
    },
    editMenu(e) {
      e.isEnable = e.isEnable ? "0" : "1";
      if (e.parentId === "00000000-0000-0000-0000-000000000000") {
        this.menuLevel = 0;
        this.dialogFirst = false;
        this.dialogSecond = false;
        this.dialogFirstEdit = true;
        this.dialogSecondEdit = false;
      } else {
        this.menuLevel = 1;
        this.dialogFirst = false;
        this.dialogSecond = false;
        this.dialogFirstEdit = false;
        this.dialogSecondEdit = true;
      }
      this.menuform.name = e.label;
      this.menuform.isEnable = e.isEnable;
      this.menuform.parentId = e.parentId;
      this.menuform.url = e.url;
      this.menuform.icon = e.icon;
      this.menuform.code = e.code;
      this.menuform.description = e.description;
      this.menuform.sortNum = e.sortNum;
      this.menuform.id = e.id;
    },
    getDataList() {
      let that = this;
      GetAllMenus().then((res) => {
        let data = res.result.filter(a=>a.code != "MultiBrand_View" && a.code != "EmcStationMonitorScreen_View");
        data = JSON.stringify(data).replace(/name/g, "label");
        that.MenuData = JSON.parse(data);
      });
    },
    onSubmit(menuform) {
      this.$refs[menuform].validate((valid) => {
        if (valid) {
          let that = this;
          let isEnable = this.menuform.isEnable === "0";
          delete this.menuform.isEnable;
          this.menuform.sortNum = parseInt(this.menuform.sortNum);
          if (this.menuLevel === 0) {
            delete this.menuform.parentId;
          }
          let data = {
            menuLevel: this.menuLevel,
            isEnable,
            code: this.menuform.name,
            ...this.menuform,
          };
          if (this.menuform.id) {
            UpdateMenu(data).then((res) => {
              if (res.success) {
                that.getDataList();
                that.$message.success(this.$t("tips.updateSuccess"));
                that.dialogFirstEdit = false;
                that.dialogSecondEdit = false;
                that.menuform = {
                  name: "",
                  isEnable: "",
                  parentId: "",
                  url: "",
                  code: "",
                  icon: "",
                  description: "",
                  sortNum: "",
                };
              }
            });
          } else {
            CreateMenu(data).then(
              (res) => {
                if (res.success) {
                  that.getDataList();
                  that.$message.success(this.$t("tips.createSuccess"));
                  that.dialogFirst = false;
                  that.dialogSecond = false;
                  that.menuform = {
                    name: "",
                    isEnable: "",
                    parentId: "",
                    code: "",
                    url: "",
                    icon: "",
                    description: "",
                    sortNum: "",
                  };
                }
              },
              (err) => {
                console.log(err);
              }
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
};
</script>

<style>
.el-tree {
  /* border: 1px solid #d2d2d2; */
  border-radius: 24px;
  overflow: hidden;
  background-color: #242731;
  padding: 20px;
}

.el-tree-node__content {
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #fff;
  display: block;
  padding-right: 10px;
  border-radius: 16px;
}
.el-tree-node__content:hover {
  background-color: rgba(245, 247, 250, 0.2);
}
.el-tree-node:focus>.el-tree-node__content{
  background-color: #1E2128;
}
.el-tree-node__expand-icon {
  color: #fff;
}

.el-tree-node__children .custom-tree-node {
  font-size: 12px;
  color: #828393;
}

.el-tree .el-button.is-circle {
  padding: 4px;
}
.iconList {
  width: 36px;
  height: 36px;
  text-align: center;
  border: 1px solid #414248;
}

.iconList i {
  padding: 12px;
  color:#fff;
}

.iconList:hover {
  border: 1px solid #219aff;
}

.icons {
  display: flex;
  flex-wrap: wrap;
}

.fa-li.fa-lg {
  left: 0;
}

.fa-li {
  position: relative;
  top: 0;
}
</style>
